import { WithNoProgress } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/components/ConditionsAndProgress/ProgressBarAndTimeline/_shared/WithNoProgress';
import { WithProgressWorkflow } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/components/ConditionsAndProgress/ProgressBarAndTimeline/ProgressWorkflow/WithProgressWorkflow/WithProgressWorkflow';
import { PaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/entities/PaymentMethodDetail/PaymentMethodDetailEntity';

interface ProgressBarAndTimelineProps {
  paymentMethodDetailEntity: PaymentMethodDetailEntity;
}

export const ProgressWorkflowBarAndTimeline = ({ paymentMethodDetailEntity }: ProgressBarAndTimelineProps) => {
  if (paymentMethodDetailEntity.paymentMethodId) {
    return <WithProgressWorkflow paymentMethodDetailEntity={paymentMethodDetailEntity} />;
  }

  return <WithNoProgress paymentMethodDetailEntity={paymentMethodDetailEntity} />;
};
